<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="small"
    >
      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('form_label_functionName') || '接口名称'">
            <el-input
              v-model="formData.functionName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              size="small"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('form_label_recordNo') || '记录编号'">
            <el-input
              v-model="formData.recordNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              size="small"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 24}" :lg="{span: 24}">
          <el-form-item :label="$l('form_label_recordJson') || '返回记录'">
            <el-input
              type="textarea"
              rows="3"
              v-model="formData.recordJson"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              clearable
              size="small"
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
            <el-date-picker
              v-model="formData.creationTime"
              type="datetime"
              size="small"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$l('INDEX.tips_select_time') || '选择日期'"
              style="width: 100%"
              readonly
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item
            :label="$l('INDEX.table_label_modification_date') || '修改时间'"
          >
            <el-date-picker
              v-model="formData.updatedTime"
              type="datetime"
              size="small"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$l('INDEX.tips_select_time') || '选择日期'"
              style="width: 100%"
              readonly
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{span: 24}" :md="{span: 12}" :lg="{span: 12}">
          <el-form-item :label="$l('form_label_recordStatus') || '记录状态'">
            <el-radio-group v-model="formData.recordStatus" disabled>
              <el-radio label="N">{{
                $l('form_label_recordStatus_N') || '未处理'
              }}</el-radio>
              <el-radio label="Y">{{
                $l('form_label_recordStatus_Y') || '已处理'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
//import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    recordCode: String,
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.recordCode) return
      this.$api
        .thdapiOaFailureRecordDetailApi({
          recordCode: this.recordCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
